import React, { useState, useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Header from '../../components/Header';

// Actions
import { gameActions } from '../../actions';

const New = () => {
  // State
  const [state, setState] = useState({
    instructors: [],
    name: '',
    instructor: '',
    type: 'csv',
  });

  // Hooks
  const user = useSelector((state) => state.authentication.user);
  const game = useSelector((state) => state.game);
  const dispatch = useDispatch();

  // Logic
  const { name, instructor, type, instructors } = state;

  // Effects
  useEffect(() => {
    if (user.role === 'administrator') {
      hubGetUsers();
    } else {
      setState((prev) => ({
        ...prev,
        instructors: [user],
        instructor: user._id,
      }));
    }
  }, [user]);

  // If there's game data, then Navigate to it
  useEffect(() => {
    if (game.data) {
      setState((prev) => ({
        ...prev,
        data: game.data,
      }));
    }
  }, [game.data]);

  // Methods
  const handleChange = (e) => {
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const setType = (newType) => {
    setState((prev) => ({
      ...prev,
      type: newType,
    }));
  };

  const hubGetUsers = () => {
    fetch(
      `${process.env.REACT_APP_API_URL}/hub/users?role[]=instructor&role[]=administrator`,
      {
        method: 'GET',
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setState((prev) => ({
          ...prev,
          instructors: data,
        }));
      });
  };

  const submit = () => {
    const data = {
      name: state.name,
      instructor: state.instructor,
      access_type: state.type,
    };
    dispatch(gameActions.createGame(data));
  };

  // If there's game data, then Navigate to it
  if (game.data && game.data._id)
    return <Navigate to={`/games/${game.data._id}`} />;

  const instructorOpts = instructors
    .sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    })
    .map((i, ii) => {
      const name =
        i.name?.length > 0 || i.lastname?.length > 0
          ? `${i.name} ${i.lastname}`.trim()
          : i.email;
      return (
        <option
          key={`ins-${ii}`}
          onClick={handleChange}
          value={i._id}>{`${name} (${i.email})`}</option>
      );
    });

  const canSubmit = name.length > 0 && type.length > 0 && instructor.length > 0;

  return (
    <div className=''>
      <Header />

      <h2 className='mt-3 sec-title fs-3'>New Game</h2>

      <div className='row mt-4'>
        <div className='col-12 col-md-8 offset-md-2'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='input-group input-group-lg'>
                <input
                  name='name'
                  className='form-control'
                  onChange={handleChange}
                  placeholder='Enter Game Name (Required)'
                />
              </div>
            </div>
            <div className='col-md-6'>
              <div className='input-group input-group-lg'>
                <select
                  name='instructor'
                  className='form-control form-select'
                  value={instructor}
                  onChange={handleChange}
                  disabled={user.role === 'instructor'}>
                  <option value=''>Select Instructor (Required)</option>
                  {instructorOpts}
                </select>
              </div>
            </div>
          </div>
          <div className='row mt-4 mb-5'>
            <div className='col-12 text-center lead mb-3'>
              Review how you add students below:
            </div>

            <div className='col-6'>
              <div
                className={
                  'card h-100 card-selectable ' +
                  (type === 'link' ? 'selected' : '')
                }
                onClick={() => setType('link')}>
                <div className='card-body'>
                  <h5>EMAIL + LINK</h5>

                  <b>Instructor/Admin:</b>
                  <ul>
                    <li>Display registration link</li>
                  </ul>

                  <b>Student Process:</b>
                  <ul>
                    <li>Register via link</li>
                    <li>Check email</li>
                    <li>Login to platform</li>
                    <li>Click on invitation</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-6'>
              <div
                className={
                  'card h-100 card-selectable ' +
                  (type === 'csv' ? 'selected' : '')
                }
                onClick={() => setType('csv')}>
                <div className='card-body'>
                  <h5>CSV</h5>

                  <b>Instructor/Admin:</b>
                  <ul>
                    <li>Upload class list</li>
                  </ul>

                  <b>Student Process:</b>
                  <ul>
                    <li>Check email</li>
                    <li>Login to platform</li>
                    <li>Click on invitation</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className='text-center col-12 mt-5'>
              <button
                className='btn btn-outline-primary btn-lg me-2'
                disabled={!canSubmit}
                onClick={submit}>
                Create
              </button>
              <Link to='/games' className='btn btn-light btn-lg ms-2'>
                Cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { New as GameNew };
